<div *ngIf="navigationItems.length > 0" id="sub-navbar" class="row"
  [class.sub-navbar-no-header]="!hasHeader"
  [class.sub-navbar-with-header]="hasHeader"  >
  <div id="sub-navbar-content" class="col-xs-12 col-sm-offset-3 col-sm-9 ">
    <ul [style.visibility]="vis" id="sub-nav" class="nav nav-pills">
      <li *ngFor="let navItem of navigationItems" [ngClass]="{'active': activeRoute.startsWith(navItem.route)}">
        <a *ngIf="keepOLH(navItem) && !hideForCL(navItem)" [id]="'subnav-id-' + navItem.id" [routerLink]="navItem.route" [queryParams]="navItem.params">{{navItem.title}}</a>
      </ul>
  </div>
</div>
